export const Error = () => {
    return <div>Pagina niet gevonden</div>;
};

export default Error;
